import Hero from '../../components/home/Hero/Hero.jsx';
import LogoStrip from '../../components/home/LogoStrip/LogoStrip.jsx';
import FeatureGrid from '../../components/home/FeatureGrid/FeatureGrid.jsx';
import Testimonials from '../../components/home/Testimonials/Testimonials.jsx';
import FAQ from '../../components/home/FAQ/FAQ.jsx';
import CTASection from '../../components/home/CTASection/CTASection.jsx';

export default function Home() {
  return (
    <>
      <Hero />
      <LogoStrip />
      <FeatureGrid />
      <Testimonials />
      <FAQ />
      <CTASection />
    </>
  );
}
